import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'amountInput', 'error', 'errorLink', 'cta', 'envelopeError', 'minimumError'];
  static values = { hasEnvelope: Boolean, remainingEnvelope: Number, commissionRate: Number, minimumAmount: Number };

  connect() {
    this.#watchSelect2Selection();
    this.update();
  }

  disconnect() {
    this.select2Observer?.disconnect();
  }

  update() {
    const option = this.selectTarget.selectedOptions[0];
    const amount = parseFloat(this.amountInputTarget.value) || 0;

    const kycBlocked = this.#toggleKyc(option);
    const envelopeBlocked = this.#toggleEnvelope(amount);
    const minimumBlocked = this.#toggleMinimum(amount);

    this.ctaTarget.disabled = kycBlocked || envelopeBlocked || minimumBlocked;

    this.dispatch('change', {
      detail: {
        selected: Boolean(option?.value),
        blocked: option?.dataset.blocked === 'true',
        name: option?.dataset.name || '',
        balance: parseFloat(option?.dataset.balance) || 0,
        beneficiary: option?.dataset.beneficiary || '',
        iban: option?.dataset.virtualIban || '',
        bic: option?.dataset.virtualBic || '',
        amount,
        commissionRate: this.commissionRateValue,
      },
    });
  }

  #watchSelect2Selection() {
    this.select2Observer = new MutationObserver(() => this.update());
    this.select2Observer.observe(this.selectTarget.parentNode, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title'],
    });
  }

  #toggleKyc(option) {
    const blocked = option?.dataset.blocked === 'true';

    if (blocked) {
      this.errorLinkTarget.href = option.dataset.profilePath;
      this.errorTarget.classList.remove('d-none');
    } else {
      this.errorTarget.classList.add('d-none');
    }

    return blocked;
  }

  #toggleEnvelope(amount) {
    if (!this.hasEnvelopeValue) return false;
    if (this.remainingEnvelopeValue <= 0) return true;

    const exceeded = amount > this.remainingEnvelopeValue;

    if (this.hasEnvelopeErrorTarget) {
      this.envelopeErrorTarget.classList.toggle('d-none', !exceeded);
    }

    return exceeded;
  }

  #toggleMinimum(amount) {
    const belowMinimum = amount < this.minimumAmountValue;

    if (this.hasMinimumErrorTarget) {
      this.minimumErrorTarget.classList.toggle('d-none', !(amount > 0 && belowMinimum));
    }

    return belowMinimum;
  }
}
